module.exports = __webpack_public_path__ + "img/saas_5.4b8d0676.png";